"use client";

import React from "react";
import { TrendingUp, Lock, Landmark, FileWarning } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const problems = [{
  title: "Escalating Maintenance Fees",
  description: "Annual fees that consistently outpace inflation, creating an unpredictable and ever-growing financial burden.",
  icon: TrendingUp
}, {
  title: "Restricted Availability",
  description: "Difficulty booking desired dates or locations, making the timeshare virtually unusable when you actually want it.",
  icon: Lock
}, {
  title: "Lifelong Debt Burden",
  description: "High-interest mortgages tied to depreciating assets that offer no return on investment and are difficult to sell.",
  icon: Landmark
}, {
  title: "Deceptive Contracts",
  description: "Complex agreements often signed under high-pressure sales tactics with unclear terms and hidden clauses.",
  icon: FileWarning
}];
export default function TheRealityOfOwnership() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="the-reality-of-ownership" className="bg-background py-20 lg:py-32 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div ref={ref} className={`transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="text-center max-w-3xl mx-auto mb-16">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-primary font-default tracking-tight">
              The Reality of Ownership
            </h2>
            <p className="mt-4 text-lg text-foreground/80">
              Understanding the common pitfalls and hidden costs that trap many
              well-intentioned buyers.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {problems.map((problem, i) => <div key={i} data-index={i} className={`transition-all duration-700 delay-[${i * 150}ms] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
                <Card className="bg-card border-none shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-2 h-full flex flex-col">
                  <CardHeader className="pb-4">
                    <div className="w-12 h-12 rounded-lg bg-secondary/10 flex items-center justify-center mb-4">
                      <problem.icon className="w-6 h-6 text-secondary" />
                    </div>
                    <CardTitle className="text-xl text-primary font-default leading-tight">
                      {problem.title}
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="flex-grow">
                    <CardDescription className="text-base text-foreground/70 leading-relaxed">
                      {problem.description}
                    </CardDescription>
                  </CardContent>
                </Card>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}